export class Alt1TooltipManager {
    constructor() {
        this.active_instance = null;
    }
    setTooltip(tooltip) {
        if (this.active_instance)
            this.removeTooltip(this.active_instance);
        alt1.setTooltip(tooltip);
        return this.active_instance = new Alt1TooltipManager.Instance(tooltip, this);
    }
    removeTooltip(instance) {
        if (this.active_instance == instance) {
            alt1.clearTooltip();
            this.active_instance = null;
        }
    }
}
(function (Alt1TooltipManager) {
    class Instance {
        constructor(text, manager) {
            this.text = text;
            this.manager = manager;
        }
        remove() {
            this.manager.removeTooltip(this);
        }
        endLifetime() {
            this.remove();
        }
    }
    Alt1TooltipManager.Instance = Instance;
})(Alt1TooltipManager || (Alt1TooltipManager = {}));
